"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconChevronLeft', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M5.29325 8.70725C4.90225 8.31625 4.90225 7.68425 5.29325 7.29325L9.29325 3.29325C9.68425 2.90225 10.3163 2.90225 10.7073 3.29325C11.0983 3.68425 11.0983 4.31625 10.7073 4.70725L7.41425 8.00025L10.7073 11.2933C10.9023 11.4883 11.0002 11.7442 11.0002 12.0002C11.0002 12.2562 10.9023 12.5122 10.7073 12.7072C10.3163 13.0982 9.68425 13.0982 9.29325 12.7072L5.29325 8.70725Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M8.41425 10.0002L13.7073 4.70725C14.0983 4.31625 14.0983 3.68425 13.7073 3.29325C13.3163 2.90225 12.6843 2.90225 12.2933 3.29325L6.29325 9.29325C5.90225 9.68425 5.90225 10.3163 6.29325 10.7073L12.2933 16.7072C12.4883 16.9022 12.7442 17.0002 13.0002 17.0002C13.2562 17.0002 13.5123 16.9022 13.7073 16.7072C14.0983 16.3162 14.0983 15.6843 13.7073 15.2933L8.41425 10.0002Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M10.0971 12.0003L16.4487 5.6487C16.9179 5.1795 16.9179 4.4211 16.4487 3.9519C15.9795 3.4827 15.2211 3.4827 14.7519 3.9519L7.55191 11.1519C7.08271 11.6211 7.08271 12.3795 7.55191 12.8487L14.7519 20.0487C14.9859 20.2827 15.2931 20.4003 15.6003 20.4003C15.9075 20.4003 16.2147 20.2827 16.4487 20.0487C16.9179 19.5795 16.9179 18.8211 16.4487 18.3519L10.0971 12.0003Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M13.4628 16.0004L21.9316 7.53159C22.5572 6.90599 22.5572 5.89479 21.9316 5.26919C21.306 4.64359 20.2948 4.64359 19.6692 5.26919L10.0692 14.8692C9.44358 15.4948 9.44358 16.506 10.0692 17.1316L19.6692 26.7316C19.9812 27.0436 20.3908 27.2004 20.8004 27.2004C21.21 27.2004 21.6196 27.0436 21.9316 26.7316C22.5572 26.106 22.5572 25.0948 21.9316 24.4692L13.4628 16.0004Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;